// Archivo para manejar el envío de emails usando EmailJS
import emailjs from 'emailjs-com';

// Configuración para EmailJS
// Necesitarás crear una cuenta en https://www.emailjs.com/ (tienen un plan gratuito)
// y configurar un servicio y una plantilla
const EMAIL_SERVICE_ID = 'YOUR_EMAIL_SERVICE_ID'; // Reemplazar con tu ID de servicio
const EMAIL_TEMPLATE_ID = 'YOUR_EMAIL_TEMPLATE_ID'; // Reemplazar con tu ID de plantilla
const EMAIL_USER_ID = 'YOUR_EMAIL_USER_ID'; // Reemplazar con tu ID de usuario

// Inicializa el servicio de EmailJS
const initEmailService = () => {
  emailjs.init(EMAIL_USER_ID);
  console.log('EmailJS service initialized');
};

// Función alternativa que no depende de EmailJS para pruebas iniciales
const sendEmailAlternative = async (formData, onSuccess, onError) => {
  try {
    // Simulamos el envío de email para pruebas
    console.log('Simulando envío de email con los siguientes datos:', {
      to: 'diegusoria@gmail.com',
      from: formData.email,
      subject: formData.subject,
      message: formData.message,
      name: formData.name
    });
    
    // Simulamos un retraso de red
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Simulamos una respuesta exitosa
    const mockResponse = {
      status: 200,
      text: 'OK'
    };
    
    if (onSuccess) {
      onSuccess(mockResponse);
    }
    
    return mockResponse;
  } catch (error) {
    console.error('Error en simulación de envío:', error);
    
    if (onError) {
      onError(error);
    }
    
    throw error;
  }
};

// Envía un correo electrónico usando EmailJS
const sendEmail = async (formData, onSuccess, onError) => {
  try {
    // Preparar los parámetros para la plantilla
    const templateParams = {
      to_email: 'diegusoria@gmail.com', // Email de destino fijo
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject || 'Mensaje desde el sitio web',
      message: formData.message,
      reply_to: formData.email,
    };

    // Enviar el email
    const response = await emailjs.send(
      EMAIL_SERVICE_ID,
      EMAIL_TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', response);
    
    // Guardar en localStorage para seguimiento (opcional)
    const contactHistory = JSON.parse(localStorage.getItem('contactHistory') || '[]');
    contactHistory.push({
      timestamp: new Date().toISOString(),
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      // No guardar el mensaje completo por privacidad
      messagePreview: formData.message.substring(0, 30) + '...',
    });
    localStorage.setItem('contactHistory', JSON.stringify(contactHistory));

    // Ejecutar callback de éxito
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess(response);
    }

    return response;
  } catch (error) {
    console.error('Error sending email:', error);
    
    // Ejecutar callback de error
    if (onError && typeof onError === 'function') {
      onError(error);
    }

    throw error;
  }
};

// Valida los datos del formulario antes de enviar
const validateFormData = (formData) => {
  const errors = {};
  let isValid = true;

  // Validar nombre
  if (!formData.name || formData.name.trim() === '') {
    errors.name = 'El nombre es obligatorio';
    isValid = false;
  }

  // Validar email con regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.email || !emailRegex.test(formData.email)) {
    errors.email = 'Por favor ingresa un correo electrónico válido';
    isValid = false;
  }

  // Validar asunto
  if (!formData.subject || formData.subject.trim() === '') {
    errors.subject = 'El asunto es obligatorio';
    isValid = false;
  }

  // Validar mensaje
  if (!formData.message || formData.message.trim() === '') {
    errors.message = 'El mensaje es obligatorio';
    isValid = false;
  } else if (formData.message.length < 10) {
    errors.message = 'El mensaje debe tener al menos 10 caracteres';
    isValid = false;
  }

  return { isValid, errors };
};

// Instrucciones para implementar EmailJS
const emailJsInstructions = `
Pasos para configurar EmailJS:

1. Crear una cuenta en EmailJS (https://www.emailjs.com/)
2. Crear un servicio (conectar tu cuenta de email - Gmail, Outlook, etc.)
3. Crear una plantilla de email con las variables:
   - {{from_name}} - Nombre del remitente
   - {{from_email}} - Email del remitente
   - {{subject}} - Asunto del mensaje
   - {{message}} - Contenido del mensaje
4. Obtener los IDs necesarios (Service ID, Template ID y User ID)
5. Reemplazar las constantes al inicio de este archivo
6. Descomentar las líneas que usan EmailJS en el componente ContactSection
`;

// Exportar funciones y constantes (una sola exportación)
export {
  initEmailService,
  sendEmail,
  sendEmailAlternative,
  validateFormData,
  emailJsInstructions
};